import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import ReactModal from 'react-modal';
import 'react-error-boundary';
import '../../theme/globalStyles.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import '../../theme/base/index.js';
import '../../theme/baseFit/index.js';
import '../../theme/pureGym/index.js';
import '../../theme/fitnessWorld/index.js';
import { Button } from '../button/index.js';
import { Heading } from '../heading/index.js';
import '../icons/generated/360Tour.js';
import '../icons/generated/Accessibility.js';
import '../icons/generated/AccountCircle.js';
import '../icons/generated/Account.js';
import '../icons/generated/ArrowDownAlt.js';
import '../icons/generated/ArrowDown.js';
import '../icons/generated/ArrowLeft.js';
import '../icons/generated/ArrowRight.js';
import '../icons/generated/ArrowUpAlt.js';
import '../icons/generated/ArrowUp.js';
import '../icons/generated/Asterisk.js';
import '../icons/generated/Book.js';
import '../icons/generated/Building.js';
import '../icons/generated/Calendar.js';
import '../icons/generated/Chat.js';
import '../icons/generated/CheckCircle.js';
import '../icons/generated/Check.js';
import '../icons/generated/CircleEmpty.js';
import '../icons/generated/ClassEndurance.js';
import '../icons/generated/ClassFatburn.js';
import '../icons/generated/ClassFullbody.js';
import '../icons/generated/ClassMobility.js';
import '../icons/generated/ClassStrength.js';
import '../icons/generated/ClassTargetArea.js';
import '../icons/generated/ClassTone.js';
import '../icons/generated/ClassWellbeing.js';
import '../icons/generated/Clock.js';
import { IconClose } from '../icons/generated/Close.js';
import '../icons/generated/ColorPalette.js';
import '../icons/generated/ColorPicker.js';
import '../icons/generated/CookieBite.js';
import '../icons/generated/CreditCard.js';
import '../icons/generated/Cvv.js';
import '../icons/generated/Dash.js';
import '../icons/generated/Documents.js';
import '../icons/generated/DoorOpen.js';
import '../icons/generated/Email.js';
import '../icons/generated/Facebook.js';
import '../icons/generated/FullscreenExit.js';
import '../icons/generated/Fullscreen.js';
import '../icons/generated/Grid.js';
import '../icons/generated/GymFeature100FreeClasses.js';
import '../icons/generated/GymFeature150FreeClasses.js';
import '../icons/generated/GymFeature200FreeClasses.js';
import '../icons/generated/GymFeature200Kit.js';
import '../icons/generated/GymFeature200KitMachine.js';
import '../icons/generated/GymFeature220Kit.js';
import '../icons/generated/GymFeature2Floors.js';
import '../icons/generated/GymFeature3Floors.js';
import '../icons/generated/GymFeature40FreeClasses.js';
import '../icons/generated/GymFeature50FreeClasses.js';
import '../icons/generated/GymFeature50Kg.js';
import '../icons/generated/GymFeature60FreeClasses.js';
import '../icons/generated/GymFeature70FreeClasses.js';
import '../icons/generated/GymFeature80FreeClasses.js';
import '../icons/generated/GymFeature90FreeClasses.js';
import '../icons/generated/GymFeatureApp.js';
import '../icons/generated/GymFeatureBodyTrak.js';
import '../icons/generated/GymFeatureClasses.js';
import '../icons/generated/GymFeatureCleaning.js';
import '../icons/generated/GymFeatureDigitalClass.js';
import '../icons/generated/GymFeatureDigitalCycle.js';
import '../icons/generated/GymFeatureDumbbells50Kg.js';
import '../icons/generated/GymFeatureFreeParking.js';
import '../icons/generated/GymFeatureFreeWeightsKettle.js';
import '../icons/generated/GymFeatureHydromassage.js';
import '../icons/generated/GymFeatureKeyFob.js';
import '../icons/generated/GymFeatureLadiesOnlyArea.js';
import '../icons/generated/GymFeatureLargeFreeWeightsArea.js';
import '../icons/generated/GymFeatureNewKit.js';
import '../icons/generated/GymFeatureNewlyRefurbished.js';
import '../icons/generated/GymFeatureOpen24Hours.js';
import '../icons/generated/GymFeaturePtAvailable.js';
import '../icons/generated/GymFeatureQualityKit.js';
import '../icons/generated/GymFeatureShowers.js';
import '../icons/generated/GymFeatureYanga.js';
import '../icons/generated/GymPackageFeatureAdvancedBooking.js';
import '../icons/generated/GymPackageFeatureBenefits.js';
import '../icons/generated/GymPackageFeatureBuddy.js';
import '../icons/generated/GymPackageFeatureMultiGym.js';
import '../icons/generated/Hand.js';
import '../icons/generated/Heart.js';
import '../icons/generated/IdCard.js';
import '../icons/generated/Info.js';
import '../icons/generated/Instagram.js';
import '../icons/generated/List.js';
import '../icons/generated/Locale.js';
import '../icons/generated/Lock.js';
import '../icons/generated/LogIn.js';
import '../icons/generated/LogOut.js';
import '../icons/generated/MapPin.js';
import '../icons/generated/Map.js';
import '../icons/generated/Menu.js';
import '../icons/generated/Messenger.js';
import '../icons/generated/MultiGym.js';
import '../icons/generated/Nfc.js';
import '../icons/generated/NoContract.js';
import '../icons/generated/Phone.js';
import '../icons/generated/Plus.js';
import '../icons/generated/QrCode.js';
import '../icons/generated/Search.js';
import '../icons/generated/Snowflake.js';
import '../icons/generated/StarHalf.js';
import '../icons/generated/Star.js';
import '../icons/generated/Strava.js';
import '../icons/generated/Target.js';
import '../icons/generated/ThemeDark.js';
import '../icons/generated/ThemeLight.js';
import '../icons/generated/Ticket.js';
import '../icons/generated/Tiktok.js';
import '../icons/generated/Times.js';
import '../icons/generated/Twitter.js';
import '../icons/generated/Unlock.js';
import '../icons/generated/Warning.js';
import '../icons/generated/Weights.js';
import '../icons/generated/Whatsapp.js';
import '../icons/generated/Wifi.js';
import '../icons/generated/Youtube.js';
import { BUTTON_VARIANTS } from '../button/constants.js';

var _templateObject, _templateObject2, _templateObject3;
const ModalContent = /*#__PURE__*/styled.section.withConfig({
  displayName: "modal__ModalContent",
  componentId: "sc-sr33ty-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
const ModalHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__ModalHeader",
  componentId: "sc-sr33ty-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ", ";\n  margin-bottom: ", ";\n\n  ", " {\n    margin-block-end: 0;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.threeQuarterSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.threeQuarterSpacing;
}, Heading);
const ModalBody = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__ModalBody",
  componentId: "sc-sr33ty-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: auto;\n"])));

/**
 *
 * To enable the Modal to correctly hide the rest of the page content (using
 * `aria-hidden`), you must call `updateAppElement` with a query selector
 * identifying the root of your app.
 *
 * @example for a Gatsby site:
 * updateAppElement('#___gatsby');
 *
 * @see https://reactcommunity.org/react-modal/accessibility/
 */
const Modal = /*#__PURE__*/forwardRef(function Modal(_ref3, ref) {
  let {
    children,
    closeText,
    headingText,
    isOpen,
    modalWide,
    onAfterClose,
    onAfterOpen,
    onClose,
    showCloseButton = true,
    ...rest
  } = _ref3;
  const {
    colors,
    page,
    radii,
    spacing
  } = useTheme();
  return /*#__PURE__*/jsx(ReactModal, {
    ref: ref,
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    onRequestClose: onClose,
    defaultStyles: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: '1000',
        backgroundColor: colors.opacities.invertedStrong,
        padding: spacing.doubleSpacing
      },
      content: {
        position: 'relative',
        maxHeight: '100%',
        margin: 'auto',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: spacing.doubleSpacing,
        border: "1px solid ".concat(colors.accents.muted),
        borderRadius: radii.default,
        background: colors.background,
        maxWidth: modalWide ? page.maxWidth : '690px'
      }
    },
    ...rest,
    children: /*#__PURE__*/jsxs(ModalContent, {
      children: [/*#__PURE__*/jsxs(ModalHeader, {
        children: [/*#__PURE__*/jsx(Heading, {
          as: "h1",
          variant: "beta",
          children: headingText
        }), showCloseButton && /*#__PURE__*/jsx(Button, {
          variant: BUTTON_VARIANTS.PLAIN,
          "aria-label": closeText,
          onClick: onClose,
          children: /*#__PURE__*/jsx(IconClose, {
            title: closeText
          })
        })]
      }), /*#__PURE__*/jsx(ModalBody, {
        children: children
      })]
    })
  });
});
const updateAppElement = element => ReactModal.setAppElement(element);
Modal.defaultProps = {
  modalWide: false
};

export { Modal, updateAppElement };
